export const serversQueryKeys = {
  all: ['servers'],
  details: () => [...serversQueryKeys.all, 'detail'],
  detail: (id) => [...serversQueryKeys.details(), id],
  pagination: (page, filters = {}) => {
    // Create a consistent, serializable representation of filters
    const filterKey = Object.entries(filters)
      .filter(([, value]) => value !== undefined && value !== '')
      .map(([key, value]) => `${key}:${value}`)
      .sort()
      .join('|');

    return [...serversQueryKeys.all, 'pagination', page.toString(), filterKey];
  },
  infinite: () => [...serversQueryKeys.all, 'infinite'],
};
